import React from 'react';
import { ExitToAppOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useLogOutUser } from 'services/hooks/auth';
import { logoutBtnClasses, LogoutRoot } from './LogoutBtn.styles';


const LogoutButton = () => {
  const logOutUser = useLogOutUser();
  return (
    <LogoutRoot className={logoutBtnClasses.logoutBtn}>
      <Button onClick={logOutUser} variant="contained" color="secondary" endIcon={<ExitToAppOutlined />} type="submit">
        Log Out
      </Button>
    </LogoutRoot>
  );
};

export default LogoutButton;
